var map = {
	"./360.svg": "aac4",
	"./SWS_collections_2022_55.jpeg": "c372",
	"./SWS_collections_2022_56_web.jpeg": "7dde",
	"./SWS_collections_2022_58_web.jpeg": "1050",
	"./bag-a4.svg": "fd08",
	"./bag-a5.svg": "44dc",
	"./bag-small.svg": "d26c",
	"./bag.png": "c000",
	"./bags-small.jpg": "fb51",
	"./bags.jpg": "856f",
	"./card-3d-model.png": "61a9",
	"./color-blue.jpg": "2770",
	"./color-brick-red.jpg": "8cdd",
	"./color-white.jpg": "b01f",
	"./color-yellow.jpg": "21dc",
	"./compostable.svg": "0c94",
	"./fonts/source-sans-pro-v13-latin-300.eot": "1b7f",
	"./fonts/source-sans-pro-v13-latin-300.svg": "fd4e",
	"./fonts/source-sans-pro-v13-latin-300.ttf": "93bb",
	"./fonts/source-sans-pro-v13-latin-300.woff": "b58c",
	"./fonts/source-sans-pro-v13-latin-300.woff2": "aa3c",
	"./fonts/source-sans-pro-v13-latin-300italic.eot": "c149",
	"./fonts/source-sans-pro-v13-latin-300italic.svg": "e87d",
	"./fonts/source-sans-pro-v13-latin-300italic.ttf": "24af",
	"./fonts/source-sans-pro-v13-latin-300italic.woff": "a581",
	"./fonts/source-sans-pro-v13-latin-300italic.woff2": "0a0e",
	"./fonts/source-sans-pro-v13-latin-600.eot": "fc63",
	"./fonts/source-sans-pro-v13-latin-600.svg": "e809",
	"./fonts/source-sans-pro-v13-latin-600.ttf": "e5b7",
	"./fonts/source-sans-pro-v13-latin-600.woff": "9173",
	"./fonts/source-sans-pro-v13-latin-600.woff2": "75ae",
	"./fonts/source-sans-pro-v13-latin-600italic.eot": "fb5b",
	"./fonts/source-sans-pro-v13-latin-600italic.svg": "23d5",
	"./fonts/source-sans-pro-v13-latin-600italic.ttf": "74c6",
	"./fonts/source-sans-pro-v13-latin-600italic.woff": "8b41",
	"./fonts/source-sans-pro-v13-latin-600italic.woff2": "121c",
	"./fonts/source-sans-pro-v13-latin-900.eot": "40cb",
	"./fonts/source-sans-pro-v13-latin-900.svg": "b32c",
	"./fonts/source-sans-pro-v13-latin-900.ttf": "2760",
	"./fonts/source-sans-pro-v13-latin-900.woff": "65e2",
	"./fonts/source-sans-pro-v13-latin-900.woff2": "d687",
	"./fonts/source-sans-pro-v13-latin-900italic.eot": "a822",
	"./fonts/source-sans-pro-v13-latin-900italic.svg": "718f",
	"./fonts/source-sans-pro-v13-latin-900italic.ttf": "8f16",
	"./fonts/source-sans-pro-v13-latin-900italic.woff": "a960",
	"./fonts/source-sans-pro-v13-latin-900italic.woff2": "6e0b",
	"./fonts/source-sans-pro-v13-latin-italic.eot": "afe6",
	"./fonts/source-sans-pro-v13-latin-italic.svg": "69a9",
	"./fonts/source-sans-pro-v13-latin-italic.ttf": "19b0",
	"./fonts/source-sans-pro-v13-latin-italic.woff": "ee3f",
	"./fonts/source-sans-pro-v13-latin-italic.woff2": "8948",
	"./fonts/source-sans-pro-v13-latin-regular.eot": "d067",
	"./fonts/source-sans-pro-v13-latin-regular.svg": "2e66",
	"./fonts/source-sans-pro-v13-latin-regular.ttf": "9804",
	"./fonts/source-sans-pro-v13-latin-regular.woff": "e488",
	"./fonts/source-sans-pro-v13-latin-regular.woff2": "cf67",
	"./homemade.svg": "c49f",
	"./large-transparent.png": "df00",
	"./logo-color.svg": "b154",
	"./logo-header-color.svg": "ae4c",
	"./logo-header.svg": "c818",
	"./logo-text-only-black.svg": "d57d",
	"./logo-text-only.svg": "e454",
	"./logo.svg": "9b19",
	"./ogm.svg": "f853",
	"./piecesInfo": "aeea",
	"./piecesInfo.json": "aeea",
	"./plants.svg": "4a13",
	"./productsInfo": "1242",
	"./productsInfo.json": "1242",
	"./productsList": "03ec",
	"./productsList.json": "03ec",
	"./protected-factory.svg": "a41c",
	"./recycle.svg": "c34b",
	"./scissors-light.svg": "ab5a",
	"./scissors.svg": "fbb3",
	"./second-life.svg": "cf3d",
	"./seedpaper-berry-gloss.png": "b662",
	"./seedpaper-black.png": "bfaa",
	"./seedpaper-exuberant-orange.png": "2c1e",
	"./seedpaper-irish-jig.png": "a575",
	"./seedpaper-spring-break.png": "24bc",
	"./seedpaper-swiss-red.png": "8e48",
	"./seedpaper-white.jpg": "6fec",
	"./seeds.svg": "6013",
	"./shop-items-definitions": "aa03",
	"./shop-items-definitions.json": "aa03",
	"./step1.svg": "3b72",
	"./step2.svg": "30a8",
	"./step3": "56d5",
	"./step3.json": "56d5",
	"./step3.svg": "7bee",
	"./step4": "bbe9",
	"./step4.json": "bbe9",
	"./step4.svg": "713d",
	"./swiss-eco-bags-1.jpg": "2daf",
	"./swiss-eco-bags-2.jpg": "2668",
	"./swiss.svg": "517e",
	"./thanks.svg": "bd2f",
	"./yourlogo.svg": "fbe9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";